import { render } from "./header.vue?vue&type=template&id=11d75fc1&scoped=true"
const script = {}

import "./header.vue?vue&type=style&index=0&id=11d75fc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d75fc1"]])

export default __exports__